export default function ProductCarriers() {
  return {
    productCategory: 'WL',
    productCarrierData: [
      {
        carrierName: "Corebridge",
        displayOrder: 1,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/corebridge.png",
      },
      {
        carrierName: "Gerber",
        displayOrder: 2,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/gerber.png",
      },
      {
        carrierName: "Mass mutual",
        displayOrder: 3,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/mass-mutual.png",
      },
      {
        carrierName: "Mutual of omaha",
        displayOrder: 4,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/mutual-of-omaha.png",
      },
      {
        carrierName: "Nationwide",
        displayOrder: 5,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/nationwide.png",
      },
      {
        carrierName: "Pacific life",
        displayOrder: 6,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/pacific-life.png",
      },
      {
        carrierName: "Sbli",
        displayOrder: 7,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/sbli.png",
      },
      {
        carrierName: "Transamerica",
        displayOrder: 8,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/transamerica.png",
      },
    ],
  }
}
